import { useState } from 'react';
import { useLocation } from 'react-router-dom';

import map from 'lodash/map';

import {
  Box as BaseBox,
  Collapse,
  Icon,
  IconName,
  styled,
  Typography,
  useTheme,
} from '@sbv-clients/ui-shared';

import { SideBarMenuItem } from '../types';
import { LabelToIconMapper } from './constants';
import SidebarNavSection from './sidebar-nav-section';

const Label = styled(Typography)<{ selected: boolean }>`
  color: ${({ theme }) => theme.background.darkGrey3};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  letter-spacing: -0.15px;
  line-height: 20px;
`;

const Box = styled(BaseBox)`
  &:hover,
  & [data-active='true'] {
    cursor: pointer;
  }
`;

const SidebarNavSectionWithChildren = ({
  item,
  active,
}: {
  item: SideBarMenuItem;
  active: boolean;
}) => {
  const [isCollapsed, setIsCollapsed] = useState(active);

  const handleCollapseToggle = () => {
    setIsCollapsed(!isCollapsed);
  };

  const router = useLocation();
  const currentRoute = router.pathname;
  const theme = useTheme();
  const isParentActive = item.children?.some((child) =>
    currentRoute.startsWith(child.link ?? '')
  );
  return (
    <>
      <Box
        data-active={active ? 'true' : ''}
        onClick={handleCollapseToggle}
        display="flex"
        alignItems="center"
        borderRadius={'10px'}
        mb={'8px'}
        sx={{
          padding: '12px 20px',
          '&:hover': {
            backgroundColor: theme.colors.primary.light,
          },
          backgroundColor: isParentActive ? theme.colors.primary.light : null,
        }}
      >
        <Icon
          sx={{
            color: isParentActive
              ? theme.colors.primary.main
              : theme.background.darkGrey,
          }}
          name={LabelToIconMapper[item?.label as IconName]}
        />
        <Label
          selected={!!(isParentActive && !isCollapsed)}
          pl={'12px'}
          flexGrow={1}
        >
          {item?.label}
        </Label>
        <Icon
          sx={{
            color: theme.background.darkGrey2,
            transform: isCollapsed ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.3s ease',
          }}
          name="KeyboardArrowDownRoundedIcon"
        />
      </Box>
      <Collapse in={isCollapsed}>
        {map(item?.children, (singleItem) => {
          const active = currentRoute.startsWith(singleItem.link ?? '');
          return (
            <SidebarNavSection
              withLink
              key={`children_${singleItem.id}`}
              item={singleItem}
              active={active}
              isChild={true}
            />
          );
        })}
      </Collapse>
    </>
  );
};

export default SidebarNavSectionWithChildren;
